
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';
import request from '@utils/request';
import { PLACE_ENUM, FULL_SIZE_COLUMN } from '@utils/constants';
import { Spin, Card, Row, Col, Button, Table } from 'antd';
import FileSaver from 'file-saver';
import domtoimage from 'dom-to-image';
import { formatNumber, searchText, initProductMeta, groupBy, formatDate, removeAccent } from '@utils/helper';
import './style.less';
import Filter from '@common/ProductFilter';

const FILTER = { name: '', categoryOperator: 'in'}
const ITEM_PER_PAGE = 10;

function ProductExport(props) {
  const [filter, setFilter] = useState({...FILTER});
  const [categoryList, setCategoryList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [materialList, setMaterialList] = useState([]);
  const [patternList, setPatternList] = useState([]);
  const [colorList, setColorList] = useState([]);
  const [showGrid, setShowGrid] = useState(false);
  const [gridPage, setGridPage] = useState(1);
  const { isLoading, mutate: getProductList } = useMutation(() => {
    return request.get('v1/product-meta');
  },
    {
      onSuccess: (response) => {
        const productList = initProductMeta(response.data);
        setProductList(productList);
        const mList = groupBy(productList, 'material');
        setMaterialList(mList.sort((a, b) => a.localeCompare(b)));
        const pList = groupBy(productList, 'pattern');
        setPatternList(pList.sort((a, b) => a.localeCompare(b)));
        const cList = groupBy(productList, 'color');
        setColorList(cList.sort((a, b) => a.localeCompare(b)));
      },
    });
  useEffect(() => {
    getProductList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const columns = [
    {
      title: '',
      dataIndex: 'id',
      render: (value) => PLACE_ENUM[value]
    },  
  ]
  FULL_SIZE_COLUMN.forEach(s => {
    columns.push({
      title: s,
      dataIndex: s
    })
  })

  const handleChangeFilter = (data) => {
    const { fieldName, fieldValue } = data;
    let temp = {...filter};
    if (fieldValue !== undefined) {
      temp[fieldName] = fieldValue;
    } else {
      temp = { ...FILTER }
    }
    setFilter(temp);
    setGridPage(1);
  }

  const handleDownloadGrid = async () => {
    var node = document.querySelector('.productGrid');
    const name = node.getAttribute('data-name');
    domtoimage.toBlob(node)
      .then(function (blob) {
        FileSaver.saveAs(blob, `${name}.png`);
      });
  }

  const renderProductGridItem = (item) => {
    const orgPrice = item.price / 1000;
    const imageSrc = item.image ? item.image.replace('https://otina.n4u.vn/', 'https://otina-proxy.n4u.vn/') : '';
    let sku = item.pSku.toUpperCase();
    return (
      <div className='item' style={{ backgroundImage: `url(${imageSrc})` }}>
        <div className='sku'>{sku}</div>
        <div className='price'>
          <span className='salePrice'>{`${orgPrice}k`}</span>
          <span>{` - `}</span>
          <span className='salePrice'>{item.inventoryQuantity}</span>
          <span>{` - `}</span>
          <span className='salePrice'>{item.sell}</span>
        </div>
      </div>
    )
  }

  const renderProductGrid = (dataSource, title = '') => {
    const startInd = (gridPage - 1)*ITEM_PER_PAGE;
    const endInd = gridPage*ITEM_PER_PAGE;
    const groupList = dataSource.filter(x => x.image);
    const list = groupList.slice(startInd, endInd);
    let fileTitle = `${formatDate(new Date(),'-','')}${title}-page-${gridPage}`.replace(/\s/g, '');
    fileTitle = removeAccent(fileTitle);
    return (
      <div className='productGrid' data-name={fileTitle}>
        <div className='productGridTile'>{title}</div>
        {list.map((item) => renderProductGridItem(item))}
      </div>
    )
  }

  const renderProductDetail = (item, ind) => {
    // const sku = p.code.toLowerCase();
    // const item = productList.find(x => x.pSku === sku);
    // if (!item) return '';
    const cover = (
      <p>
        <img alt={item.pName} src={item.image} />
      </p>
    );
    return (
      <Col sm={6} style={{ marginBottom: 16 }} key={item.pSku}>
        <Card className='productItem' hoverable cover={cover}>
          <div style={{ height: 42 }}>{item.pName} - {item.pSku}</div>
          <div style={{ fontSize: 20 }}>{formatNumber(item.price)}</div>
          <div>
            <Table 
              dataSource={item.inventory} 
              columns={columns} 
              className='metaTable'
              bordered={false}
              pagination={false}
              size="small" 
              locale={{emptyText: '-'}}
            />
          </div>
        </Card>
      </Col>
    )
  }

  let title = '';
  let dataSource = productList;
  if (filter.id) {
    const fId = parseInt(filter.id, 0);
    dataSource = productList.filter(x => x.id === fId);
  }
  else if (filter.name || filter.material || filter.pattern || filter.color || filter.category) {
    title += filter.name ? ` - ${filter.name}` : '';
    title += filter.material ? ` - ${filter.material}` : '';
    title += filter.pattern ? ` - ${filter.pattern}` : '';
    if(filter.category){
      const cat = categoryList.find(x => x.id === filter.category);
      if(cat){
        title += ` - ${cat.name}`
      }
    }
    dataSource = productList.filter(x => {
      let result = true;
      if(filter.name) 
        result = searchText(x.pName, filter.name) || searchText(x.pSku, filter.name);
      if(filter.material)
        result = result && (x.material === filter.material);
      if(filter.pattern)
        result = result && (x.pattern === filter.pattern);
      if(filter.color)
        result = result && (x.color === filter.color);
      if(filter.category){
        if(filter.categoryOperator === 'in'){
          result = result && ( x.productCategories && filter.category.some(cat => x.productCategories.includes(`;${cat};`)));
        } else {
          result = result && ( !x.productCategories || !filter.category.some(cat => x.productCategories.includes(`;${cat};`)));
        }
      }
        
      return result;
    })
  }
  if(filter.fromQuantity || filter.toQuantity){
    const fromQty = parseInt(filter.fromQuantity || 0);
    const toQty = parseInt(filter.toQuantity || 9999);
    const filterName = filter.branch ? `branch${filter.branch}` : 'inventoryQuantity';
    dataSource = dataSource.filter(x => x[filterName] < toQty && x[filterName] > fromQty);
  }
  let showNextPage = false;
  if(showGrid){
    const totalPage = Math.ceil(dataSource.length / ITEM_PER_PAGE);
    if(gridPage < totalPage) showNextPage = true;
  }

  return (
    <Spin spinning={isLoading}>
      <Row gutter={16}>
        <Col sm={12}>
          <h2>Xuất sản phẩm</h2>
        </Col>
        <Col sm={6}>
          <Button onClick={() => {setShowGrid(!showGrid)}}>{showGrid ? 'Hide Grid' : 'Show Grid'}</Button>
        </Col>
      </Row>
      <Filter 
        materialList={materialList} 
        patternList={patternList} 
        colorList={colorList} 
        filter={filter}
        onChangeFilter={handleChangeFilter}
        onLoadCategoryList={setCategoryList}
        />
      {showGrid && (
        <Row gutter={16}>
          <Col sm={2} align="right">
            <Button disabled={gridPage < 2} onClick={() => setGridPage(gridPage - 1)}>Previous</Button>
            <Button onClick={handleDownloadGrid}>Download</Button>
          </Col>
          <Col sm={20}>{renderProductGrid(dataSource, title)}</Col>
          <Col sm={2}>
          <Button disabled={!showNextPage} style={{ marginTop: 20 }} onClick={() => setGridPage(gridPage + 1)}>Next</Button>
        </Col>
        </Row>
      )}
      <Row gutter={16}>
        {dataSource.map(renderProductDetail)}
      </Row>
    </Spin>
  )
}

ProductExport.propTypes = {
  dataSource: PropTypes.array,
  categoryList: PropTypes.array,
  loading: PropTypes.bool,
};

ProductExport.defaultProps = {
  dataSource: [],
  categoryList: [],
  loading: false,
};

export default ProductExport;